import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const handleDownloadPDF_HTML2Canvas = async (
  pdfRef: any,
  fileName: string
): Promise<boolean> => {
  const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size PDF
  const pdfElement: any = pdfRef.current; // Reference to the DOM element

  try {
    if (pdfElement) {
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const marginTop = 10; // Top margin
      let yPosition = marginTop; // Current Y position for content

      const components = pdfElement?.children; // Get child elements (tables, charts, etc.)

      for (const component of components) {
        // Render each component as a canvas
        const componentCanvas = await html2canvas(component as HTMLElement, {
          scale: 2
        });
        const componentImgData = componentCanvas.toDataURL('image/png');

        // Calculate dimensions for the component
        const contentWidth = componentCanvas.width;
        const contentHeight = componentCanvas.height;
        const aspectRatio = contentWidth / contentHeight;

        // Scale to fit PDF width while maintaining aspect ratio
        const imgWidth = pdfWidth - 20; // Leave some margin
        const imgHeight = imgWidth / aspectRatio;

        // Check if the current component fits on the current page
        if (yPosition + imgHeight > pdfHeight) {
          pdf.addPage(); // Add a new page
          yPosition = marginTop; // Reset Y position for the new page
        }

        // Add the component image to the PDF
        pdf.addImage(
          componentImgData,
          'PNG',
          10,
          yPosition,
          imgWidth,
          imgHeight
        );
        yPosition += imgHeight + 10; // Add some spacing after each component
      }

      // Save the PDF
      pdf.save(`${fileName}.pdf`);
      return true; // Resolve with true when the PDF is ready
    }

    return false; // Resolve with false if pdfRef is not valid
  } catch (error) {
    console.error('Error generating PDF:', error);
    return false; // Resolve with false in case of error
  }
};
